import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const Notifications = ({ items, isFull, handleMore, handleNotification, loading }) => {
  const { t } = useTranslation(['notifications-portal'])
  return (
    <div className="ctp-notif">
      {items && items.length > 0 ? (
        <div>
          {items.map((item, i) => (
            <div onClick={() => handleNotification(item)} className="ctp-notif-wrap" key={i}>
              <p>{item.title}</p>
              <p>{item.description}</p>
            </div>
          ))}
          {!isFull && (
            <button
              className="button button-primary is-block "
              onClick={handleMore}
              disabled={loading}
            >
              {t('notifications-portal:notifications.loadMoreButton')}
            </button>
          )}
        </div>
      ) : (
        <p className="ctp-notif-empty">{t('notifications-portal:notifications.emptyMessage')}</p>
      )}
    </div>
  )
}

Notifications.propTypes = {
  items: PropTypes.array.isRequired,
  isFull: PropTypes.bool,
  handleMore: PropTypes.func,
  handleNotification: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default Notifications
